import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MngColor, MngIconComponent } from '@mng/mng-icon';
import { NgTemplateOutlet } from '@angular/common';
import { FlexDirective, LayoutAlignDirective, LayoutDirective } from '@ngbracket/ngx-layout/flex';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'mng-dialog-header',
  imports: [
    MatDialogTitle,
    CdkDrag,
    CdkDragHandle,
    LayoutDirective,
    LayoutAlignDirective,
    FlexDirective,
    MngIconComponent,
    NgTemplateOutlet
  ],
  templateUrl: './mng-dialog-header.component.html',
  styleUrl: './mng-dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MngDialogHeaderComponent {
  @Input() title: string;

  @Input() subTitle: string;

  @Input() iconName: string;

  @Input() iconColor: MngColor;
}
